import { useQuery } from "@tanstack/react-query";
import { partyApi } from "@/lib/party.api";
import { queryKeys } from "@/lib/query-keys";
import { isValidRecordId } from "@/lib/route-id";

export function usePartyHistory(partyId: number, page = 1) {
  return useQuery({
    queryKey: [...queryKeys.partyHistory(partyId), page],
    queryFn: () => partyApi.getHistory(partyId, { page }).then((r) => r.data),
    enabled: isValidRecordId(partyId),
  });
}
